<template>
  <div>
    <div class="wt2-text-n2 -subtitle">
      {{ 'assetEditor.audio' | culture }}
      <span
        v-if="canEdit"
        class="-edit-btn wt2-text-n"
        @click="$emit('action', { action: 'click' })"
      >
        {{ 'assetEditor.changeVolume' | culture }}
      </span>
    </div>
    <ul v-if="canEdit" class="list-unstyled">
      <li
        v-for="[
          key,
          { volume, icon, text, muted, reasonTooltip },
        ] in statusEntities"
        :key="key"
        :class="{
          muted: volume === 0,
          disabled: reasonTooltip,
        }"
        @click="clickOnAction(!reasonTooltip)"
        :title="'assetEditor.click2Edit' | culture"
      >
        <div class="wt-effect-display-icon">
          <i class="wticon -effect-icon" :class="[icon]" />
        </div>

        <div class="wt-effect-display-text" v-text="text" />

        <mute-action
          @mute="onMuteUnmute({ action: 'mute', key })"
          @unmute="onMuteUnmute({ action: 'unmute', key })"
          :reasonTooltip="reasonTooltip"
          :volume="volume"
        />

        <div
          v-if="showVolume"
          class="wt-effect-volume"
          :title="text + ' volume'"
          v-text="parseVolume(volume)"
        />
      </li>
    </ul>
    <div v-else class="-no-audio">
      <div>No Audio</div>
    </div>
  </div>
</template>

<script>
const muteAction = {
  props: {
    reasonTooltip: { type: Object, required: false },
    volume: { type: Number, required: true },
  },

  render(h) {
    const self = this;
    const { reasonTooltip, volume } = self;
    const directives = [];
    const attrs = {};

    if (reasonTooltip) {
      directives.push({
        name: 'tooltip',
        value: reasonTooltip,
      });
    } else if (volume === 0) {
      attrs.title = app.culture.get('assetEditor.unmute');
    } else {
      attrs.title = app.culture.get('assetEditor.mute');
    }

    return h(
      'div',
      {
        class: {
          'wt-effect-mute': true,
        },
        on: {
          click(e) {
            if (!reasonTooltip) {
              e.stopImmediatePropagation();
              if (volume > 0) {
                self.$emit('mute');
              } else {
                self.$emit('unmute');
              }
            }
          },
        },
      },
      [
        h('i', {
          style: {
            fontSize: '16px',
          },
          class: {
            wticon: true,
            '-effect-icon': true,
            mute: volume === 0,
            unmute: volume > 0,
          },
          directives,
          attrs,
        }),
      ]
    );
  },
};
export default {
  components: {
    muteAction,
  },

  props: {
    status: {
      require: true,
      validator(obj) {
        return Object.values(obj).reduce(
          (bool, obj) =>
            bool &&
            _.isNumber(obj.volume) &&
            _.isString(obj.icon) &&
            _.isString(obj.text),
          true
        );
      },
    },
    showVolume: { type: Boolean, required: false, default: true },
  },

  computed: {
    statusEntities() {
      return Object.entries(this.status);
    },

    canEdit() {
      return this.statusEntities.length;
    },
  },

  methods: {
    parseVolume(number) {
      return Math.round((number * 10000) / 95);
    },

    clickOnAction(enabled) {
      if (enabled) {
        this.$emit('action', { action: 'click' });
      }
    },

    onMuteUnmute(props) {
      this.$emit('action', props);
    },
  },
};
</script>

<style lang="scss" scoped>
.-subtitle {
  display: flex;
  justify-content: space-between;
  .-edit-btn {
    color: $color-primary;
    cursor: pointer;
    &:hover {
      color: $wt-blue-dark;
    }
  }
}

.list-unstyled {
  li {
    &.disabled {
      &:hover {
        background: white;
        cursor: default;
      }
      .wt-effect-mute {
        color: $color-black-l;
        cursor: pointer;
      }
    }

    .wt-effect-volume {
      width: 45px;
      margin: auto;
      color: $color-grey-2;
      text-align: center;
    }

    .wticon.-effect-icon.wticon-camera {
      font-size: 13px;
    }

    .wticon.-effect-icon.wticon-music-alt {
      font-size: 18px;
    }

    &:not(.disabled):hover .wt-effect-mute {
      color: $wt-blue-dark;
    }

    .wt-effect-mute {
      margin: auto;
      padding: 0 10px;
      .wticon.-effect-icon {
        font-size: 16px;
      }
      /deep/ i.mute::before {
        content: '\e9d6';
      }
      /deep/ i.unmute::before {
        content: '\e9d7';
      }
    }
  }
}

.-no-audio {
  display: flex;
  margin-top: 10px;
  width: 100%;
  height: 80px;
  background-color: rgba(0, 0, 0, 0.05);
  > div {
    margin: auto;
    color: rgba(0, 0, 0, 0.3);
    font-size: 14px;
  }
}
</style>
